{
	"v3": {
		"title": "V3",
		"key": "v3",
		"image": "https://img.qromo.io/img/V3.webp",
		"test": ["price_1TQp6GL1BrR61arWokMNfc47"],
		"live": ["price_1TQpBaL1BrR61arWz7j5Ia0V"]
	},
	"v3mix": {
		"title": "V3 Mix",
		"key": "v3mix",
		"image": "https://img.qromo.io/img/V3mix.webp",
		"test": ["price_1TQp5HL1BrR61arWS0bSeOuR"],
		"live": ["price_1TQpBfL1BrR61arW7VVx66Xb"]
	},
	"d3mini": {
		"title": "D3 Mini",
		"key": "d3mini",
		"image": "https://img.qromo.io/img/D3mini.webp",
		"test": ["price_1TQp4BL1BrR61arW9K7nuOJp"],
		"live": ["price_1TQpBhL1BrR61arWyorR32Ok"]
	},
	"d3family": {
		"title": "D3 Family",
		"key": "d3family",
		"image": "https://img.qromo.io/img/D3family.webp",
		"test": ["price_1TQp2mL1BrR61arWpZpLnzmt"],
		"live": ["price_1TQpBjL1BrR61arWwQxMOPhO"]
	},
	"qromopos700": {
		"title": "Qromo Pos Pro",
		"key": "qromo_pos_pro",
		"image": "https://img.qromo.io/img/Qromo-pos-s700.webp",
		"test": ["price_1QoMRqL1BrR61arWHeibVLDU", "price_1Os72vL1BrR61arWBcllozxk"],
		"live": ["price_1QtpTEL1BrR61arWX2Qp9pe2", "price_1Os76PL1BrR61arWmGrQXkUE"]
	},
	"qromopos": {
		"title": "Qromo Pos",
		"key": "qromo_pos",
		"image": "https://img.qromo.io/img/Qromo-pos.webp",
		"test": ["price_1QoMzkL1BrR61arWyCBKFbxI", "price_1NFzj1L1BrR61arWXW2AHQ7i", "price_1NK8GPL1BrR61arWgTvd8eiK"],
		"live": ["price_1QtpVnL1BrR61arWw5qoXPmk", "price_1NFzjOL1BrR61arWXJ81PswW", "price_1NK8JgL1BrR61arWU7f9GbiR"]
	},
	"qromobundle": {
		"title": "Qromo Bundle",
		"key": "qromo_bundle",
		"image": "https://img.qromo.io/img/Qromo-pos.webp",
		"test": ["price_1TTJVLL1BrR61arWr57BEgHt"],
		"live": ["price_1TTJZzL1BrR61arWkw1aFSEQ"]
	},
	"qromoposwisepad": {
		"title": "Qromo POS Mini",
		"key": "qromo_pos_mini",
		"image": "https://img.qromo.io/img/Qromo-pos-wise-pad.webp",
		"test": ["price_1QoNC0L1BrR61arWqR3Vzsq8", "price_1Os72GL1BrR61arWb2PJaEMu"],
		"live": ["price_1QtpX6L1BrR61arWiuzqflrA", "price_1Os76SL1BrR61arW3GqIdBpW"]
	},
	"epsonprinter": {
		"title": "Epson FP-81II RT",
		"key": "epson_fp_81ii_rt",
		"image": "https://img.qromo.io/img/Epson-printer.webp",
		"test": ["price_1QoNLJL1BrR61arW2nf9NCza", "price_1QCjw2L1BrR61arWJ6jfG0Sf"],
		"live": ["price_1QtpXdL1BrR61arWkar4bZ0T", "price_1QCjVhL1BrR61arWaOOn32bB"]
	},
	"qromoprinter": {
		"title": "Qromo Printer",
		"key": "qromo_printer",
		"image": "https://img.qromo.io/img/Qromo-printer.webp",
		"test": ["price_1QojaEL1BrR61arWW7wAl29n", "price_1NK8LDL1BrR61arWy1cwGaSS"],
		"live": ["price_1QtpYML1BrR61arWAEViuJVk", "price_1NH9BRL1BrR61arWj1c6fmfT"]
	},
	"qromotabletd3": {
		"title": "Qromo Tower",
		"key": "qromo_tower",
		"image": "https://img.qromo.io/img/Qromo-tablet-d3.webp",
		"test": ["price_1QojPZL1BrR61arW3VMMhTRM", "price_1QCjqXL1BrR61arWs1KHjAG1"],
		"live": ["price_1QtpbLL1BrR61arWUzIVHPwG", "price_1QCjT3L1BrR61arWEmK3S1VM"]
	},
	"qromotablethonor": {
		"title": "Tablet Android",
		"key": "tablet_android",
		"image": "https://img.qromo.io/img/Qromo-tablet-honor-new.webp",
		"test": ["price_1QojSwL1BrR61arWYQR3iP9E", "price_1QCjv8L1BrR61arWf3e2bT5n"],
		"live": ["price_1QtpcRL1BrR61arWydTNNuKv", "price_1QCjUAL1BrR61arWGGSyP72u"]
	},
	"shipping_low": {
		"test": ["price_1QojcNL1BrR61arWGUG9cmXB", "price_1NK87sL1BrR61arW257K7vBF"],
		"live": ["price_1QtpdsL1BrR61arWE0s18fej", "price_1NK88rL1BrR61arW2wSQbgZa"]
	},
	"shipping_high": {
		"test": ["price_1QojdwL1BrR61arW90lzkKDO", "price_1NK87sL1BrR61arW58KfDrey"],
		"live": ["price_1QtpdsL1BrR61arWWViLuJ8n", "price_1NK88rL1BrR61arWbYbDjK17"]
	},
	"load_menu" : {
		"test": ["price_1QmeyCL1BrR61arWE1DMAPpl", "price_1Lni5BC37hAZDv70tZV2Xjmk", "price_1LzkP9L1BrR61arWIWn79GuW"],
		"live": ["price_1QtpevL1BrR61arWFWhc9rZm", "price_1Lni4hC37hAZDv703FoVjkgt", "price_1LzkPSL1BrR61arWsguqJhyw"]
	},
	"cassetto_monete" : {
		"test": ["price_1QojpBL1BrR61arWq9zuMQ6m", "price_1LzkdmL1BrR61arWwfptiyCh"],
		"live": ["price_1QtpgAL1BrR61arWqRUEQmcM", "price_1LzkdxL1BrR61arWscrMRxWR"]
	},
	"palmare_android" : {
		"test": ["price_1QojrKL1BrR61arWUQ6TS4KA", "price_1LzkfYL1BrR61arWKiGtU1fN"],
		"live": ["price_1QtpgyL1BrR61arW2vOkdNBn", "price_1LzkfkL1BrR61arWOcV3Kx7h"]
	},
	"router" : {
		"test": ["price_1QojvLL1BrR61arWFRV0F7s6", "price_1LzkgsL1BrR61arW8Qd4qlK8"],
		"live": ["price_1QtphhL1BrR61arW8YMHEGTU", "price_1LzkhhL1BrR61arWgEC5lHhr"]
	},
	"qr_acrilico_6x15" : {
		"test": ["price_1Qojy1L1BrR61arWXUsLkQJy", "price_1LzkjiL1BrR61arWC3jTetjX"],
		"live": ["price_1QtpicL1BrR61arW5ZMShIMW", "price_1LzkjsL1BrR61arWeqkB1Y5Z"]
	},
	"qr_adesivo_10x5" : {
		"test": ["price_1QojzSL1BrR61arWEqHmvD3B", "price_1LzkkyL1BrR61arWxmwKkyGG"],
		"live": ["price_1QtpjPL1BrR61arW1oGQEtzM", "price_1Lzkl9L1BrR61arWI7b6Joiv"]
	},
	"stampante_comande" : {
		"test": ["price_1Qok0tL1BrR61arWgJfhtTpy", "price_1LzkoAL1BrR61arWGSsallyl"],
		"live": ["price_1QtpkzL1BrR61arW1pGY6c2Q", "price_1LzkoLL1BrR61arWkeLKg2zV"]
	},
	"stampante_fiscale" : {
		"test": ["price_1Qok2KL1BrR61arWzJmb04yo", "price_1LzkppL1BrR61arWMwzN9pGH"],
		"live": ["price_1QtplgL1BrR61arWRgSMOrsq", "price_1Lzkq2L1BrR61arWL7LfVYfh"]
	},
	"qromosun" : {
		"test": ["price_1Qok4OL1BrR61arWuWuC1IZr", "price_1NFzmVL1BrR61arWfCu8bP82"],
		"live": ["price_1QtpmRL1BrR61arWH3TBx8y9", "price_1NFzuwL1BrR61arWx6vaRcnL"]
	},
	"qromosun2" : {
		"test": ["price_1Qok6sL1BrR61arWrswhEuHc", "price_1NFznRL1BrR61arWrwjhAqAA"],
		"live": ["price_1QtpnCL1BrR61arWYI3tj0tM", "price_1NFzv0L1BrR61arWTlmYeLKm"]
	},
	"sunmicloudprinter" : {
		"test": ["price_1Qok8kL1BrR61arWhSJLYv8x", "price_1NFzrpL1BrR61arWEZvdrKpb"],
		"live": ["price_1QtpnvL1BrR61arWdbsQOSWf", "price_1NFzv4L1BrR61arWqPeg3Ac4"]
	},
	"monitor" : {
		"test": ["price_1QpZiKL1BrR61arWL4aZuuwM", "price_1Lzkc6L1BrR61arWxtTsfwFH"],
		"live": ["price_1QtpoRL1BrR61arW3REaTjpS", "price_1LzkcJL1BrR61arWCVOdt7QJ"]
	},
	"sub_free" : {
		"test": ["price_1RWzjvL1BrR61arWHnqfdbV6"],
		"live": ["price_1RX0okL1BrR61arWcR05xKuC"]
	},
	"sub_free_yearly" : {
		"test": ["price_1RWzjvL1BrR61arWAtNXmHYS"],
		"live": ["price_1RX0okL1BrR61arWkH1FZXCO"]
	},
	"sub_basic" : {
		"test": ["price_1SAB2RL1BrR61arWD1sCgaXJ", "price_1QUr3oL1BrR61arWbh3uxPpt"],
		"live": ["price_1R40eWL1BrR61arWkdqCdbQX", "price_1QUrGOL1BrR61arWqVFhPYps"]
	},
	"sub_basic_yearly" : {
		"test": ["price_1QmcIjL1BrR61arWX0ahmUkX", "price_1QUr3ML1BrR61arWVRlTeByr"],
		"live": ["price_1QtpqLL1BrR61arWvedOJRtz", "price_1QUrGOL1BrR61arWfjxVVB75"]
	},
	"sub_pro" : {
		"test": ["price_1QmeFeL1BrR61arWIS4dZEBv", "price_1QUr5KL1BrR61arWDcBlbfEA"],
		"live": ["price_1QtpugL1BrR61arWgLfuB0an", "price_1QUrGWL1BrR61arWocBqHJ7g"]
	},
	"sub_pro_yearly" : {
		"test": ["price_1QmeNVL1BrR61arWHdnqEteL", "price_1QUr4mL1BrR61arWG5hhha6Z"],
		"live": ["price_1QtpugL1BrR61arWvlUQeO4W", "price_1QUrGWL1BrR61arW4vz1Rs9J"]
	},
	"sub_allinone" : {
		"test": ["price_1QmeSbL1BrR61arWOInmCTJu", "price_1QUr6UL1BrR61arWLaPGfrUk"],
		"live": ["price_1QtpwfL1BrR61arWc1Z7MpUA", "price_1QUrGZL1BrR61arWpTbfKeAR"]
	},
	"sub_allinone_yearly" : {
		"test": ["price_1QmeQXL1BrR61arWz1x6HScf", "price_1QUr62L1BrR61arWLNLG9nGI"],
		"live": ["price_1QtpwfL1BrR61arWSZHp6U8t", "price_1QUrGZL1BrR61arW0LETWQRQ"]
	}
}